const initializeClickIdHelper = () => {
  const params = new URLSearchParams(window.location.search);

  const fbclid = params.get('fbclid') || '';
  const gclid = params.get('gclid') || '';
  const fbClickIdFields = document.querySelectorAll(
    "input[name='facebook_click_id']"
  );
  const gClickIdFields = document.querySelectorAll(
    "input[name='google_click_id']"
  );

  fbClickIdFields.forEach((field) => {
    field.value = fbclid;
  });

  gClickIdFields.forEach((field) => {
    field.value = gclid;
  });
};

export { initializeClickIdHelper };
